import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { Container } from "@react-email/components";

export interface RootProps extends ComponentPropsWithRef<"table"> {
  children: ReactNode;
}

export const RootBlock = forwardRef<HTMLTableElement, RootProps>(
  ({ children, style, ...rest }, ref) => (
    <Container
      ref={ref}
      style={{
        position: "relative",
        height: "100%",
        maxWidth: "640px",
        ...style,
      }}
      {...rest}
    >
      {children}
    </Container>
  ),
);

RootBlock.displayName = "Root";
